var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotGraphImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 490,
    viewBox: "0 0 490 490",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M96.9804 339.241C106.815 313.533 143.185 313.533 153.02 339.241L169.045 381.129C182.102 415.259 202.78 445.956 229.502 470.881L250 490H0L20.4983 470.881C47.2204 445.956 67.8983 415.259 80.9551 381.129L96.9804 339.241Z",
    fill: "url(#paint0_linear_1993_76233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M310.606 143.961C317.14 111.963 362.86 111.963 369.394 143.961L407.726 331.705C413.636 360.647 424.837 388.25 440.768 413.125L490 490H190L239.232 413.125C255.163 388.249 266.364 360.647 272.274 331.704L310.606 143.961Z",
    fill: "url(#paint1_linear_1993_76233)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1993_76233",
    x1: 125,
    y1: 266,
    x2: 125,
    y2: 490,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B50B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1993_76233",
    x1: 340,
    y1: 40,
    x2: 340,
    y2: 490,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotGraphImg);
export default __webpack_public_path__ + "static/media/ChatbotGraphImg.bef1f0c69d31b6e2d3b18e58630c4e27.svg";
export { ForwardRef as ReactComponent };